import { styled, Typography } from '@mui/material';

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

export const ItemContainer = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: '28px 28px 1fr',
  gap: 16,
  alignItems: 'flex-start',
}));

export const ItemTime = styled(Typography)(() => ({
  fontSize: '14px',
  color: '#6B7280',
}));

export const ItemIndicator = styled(Typography)(() => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  minHeight: '100%',
  gridRow: '1 / span 2',
}));

type ItemLineProps = {
  isFirst: boolean;
  isLast: boolean;
};

export const ItemLine = styled('div')<ItemLineProps>(({ isFirst, isLast }) => ({
  position: 'absolute',

  top: isFirst ? 12 : -16,
  bottom: isLast ? '60%' : -16,

  width: '2px',
  background: '#d9d9d9',
}));

type ItemBadgeProps = {
  status: 'success' | 'error';
};

export const ItemBadge = styled('div')<ItemBadgeProps>(({ status, theme }) => ({
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  zIndex: 1,
  marginTop: '4px',

  background: status === 'success' ? theme.palette.secondary.main : '#FF4C4C',
}));

export const ItemMessageWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 8,
}));

export const AuditTag = styled('span')(({ theme }) => ({
  display: 'inline-block',
  marginTop: '4px',
  padding: '2px 8px',
  borderRadius: '6px',
  fontSize: '11px',
  fontWeight: 600,
  width: 'fit-content',
  color: theme.palette.primary.main,
  background: '#E6F4F1',
}));

const Message = styled(Typography)(() => ({
  fontSize: '14px',
  lineHeight: 1.5,
  flex: 1,
  minWidth: 0,
  wordBreak: 'break-word',
  maxWidth: '210px',
}));

export const ItemMessage = styled(Message)(() => ({
  color: '#475467',
}));

export const ItemMessageLink = styled(Message)(({ theme }) => ({
  color: theme.palette.secondary.main,
  cursor: 'pointer',
  textDecoration: 'underline',
  textDecorationStyle: 'solid',
  textDecorationSkipInk: 'none',
  textDecorationThickness: 'auto',
  textUnderlineOffset: 'auto',
  textUnderlinePosition: 'from-font',

  '&:hover': {
    opacity: 0.8,
    transition: '0.3s',
  },
}));

export const ContainerError = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gridColumn: '1 / -1',
  width: '100%',

  margin: '24px 0',
}));

export const ContainerErrorTitle = styled('div')(() => ({
  display: 'flex',
  padding: 16,
  justifyContent: 'space-between',
  alignItems: 'center',
  alignSelf: 'stretch',
  borderRadius: '8px 8px 0 0',
  border: '1px solid #E3E3E3',
  background: '#FFF',
  zIndex: 2,
}));

export const TitleErrorMessage = styled('span')(() => ({
  display: 'flex',
  alignItems: 'flex-end',

  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '140%',
  gap: 8,

  '& svg': {
    color: '#FFD113',
  },
}));

export const ContainerErrorMessage = styled('div')(() => ({
  display: 'flex',
  padding: '24px 55px 24px 24px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 10,
  alignSelf: 'stretch',

  borderRadius: '0 0 8px 8px',
  border: '1px solid #E3E3E3',
  background: '#FFFFFF',

  color: '#1592EC',
  minWidth: 0,
  wordBreak: 'break-word',
}));
